
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import logo from '../assets/logo.svg';
import NavSecMobile from './NavSecMobile';
import MobileBottomNav from './MobileBottomNav';

const pages = [
  { label: 'Home', link: 'hero' },
  { label: 'Services', link: 'services' },
  { label: 'Testimonials', link: 'testimonials' },
];



const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const openConsultationForm = (source) => {
    window.dispatchEvent(
      new CustomEvent('open-consultation-form', {
        detail: { source }
      })
    )
  }

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleScroll = (id) => {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } });
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <Box>
      <Box>
        {!isMobile && <AppBar position="static" color="transparent" elevation={0} sx={{ background: 'linear-gradient(90deg, #fff 60%, #FFF3E6 100%)', boxShadow: 'none', px: 0, pt: 1 }}>
          <Toolbar sx={{ justifyContent: 'space-between', minHeight: { xs: 56, sm: 64 }, padding: '0px !important' }}>
            <Box onClick={() => navigate('/')} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <img src={logo} alt="Varahi Logo" style={{ height: 60, marginRight: 12 }} />
            </Box>
            {isMobile ? (
              <>
                <IconButton edge="end" color="inherit" onClick={handleMenu}>
                  <MenuIcon sx={{ color: '#FF6600', fontSize: 32 }} />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  {pages.map((page) => (
                    <MenuItem key={page.label} onClick={() => {
                      handleClose();
                      handleScroll(page.link);
                    }} sx={{ color: '#000' }}>
                      {page.label}
                    </MenuItem>
                  ))}
                  <MenuItem onClick={handleClose}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        handleClose()
                        openConsultationForm('navbar')
                      }}
                      sx={{ background: '#FF6600', color: '#fff', borderRadius: 2, px: 3, fontWeight: 600 }}
                    >
                      Book Now
                    </Button>
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 0 }}>
                {pages.map((page) => (
                  <Button
                    key={page.label}
                    onClick={() => handleScroll(page.link)}
                    sx={{ color: '#000', fontWeight: 500, fontSize: 16, textTransform: 'none' }}
                  >
                    {page.label}
                  </Button>
                ))}
                <Button
                  variant="contained"
                  onClick={() => openConsultationForm('navbar')}
                  sx={{ background: '#FF6600', color: '#fff', borderRadius: 2, px: 3, fontWeight: 600, ml: 2, boxShadow: 'none', '&:hover': { background: '#e65c00' } }}
                >
                  Book Now
                </Button>
              </Box>
            )}
          </Toolbar>
        </AppBar>}

        {isMobile && (
          <>
            <NavSecMobile />
            <MobileBottomNav handleScroll={handleScroll} openConsultationForm={openConsultationForm} />
          </>
        )}
      </Box>
    </Box>
  );
};

export default Navbar;
